// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__vQNlB","total":"Cart_total__Q4UiI","actions":"Cart_actions__AKmDK","button--alt":"Cart_button--alt__T8Xka","button":"Cart_button__HVhOn"};